export default __webpack_public_path__ + "static/media/female_avatar.216349b0.svg";